/**
 * Mise en forme des durées et heures d'émargement.
 *
 * Les durées sont **calculées par l'API** (`domain/presence-horaires.ts`) et
 * rendues en minutes ; l'écran ne fait que les écrire comme on les lit sur une
 * feuille d'émargement.
 */

/** « 2h », « 1h15 », « 45 min ». */
export function dureeLisible(minutes: number | null): string {
  if (minutes === null) return '—';
  if (minutes < 60) return `${minutes} min`;
  const heures = Math.floor(minutes / 60);
  const reste = minutes % 60;
  return reste === 0 ? `${heures}h` : `${heures}h${String(reste).padStart(2, '0')}`;
}

/** Heure `HH:MM` à La Réunion d'un instant ISO. */
export function heureReunion(iso: string): string {
  return new Date(iso).toLocaleTimeString('fr-FR', {
    timeZone: 'Indian/Reunion',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** « 23/09/2026 à 10:02 ». */
export function horodatageReunion(iso: string): string {
  const date = new Date(iso).toLocaleDateString('fr-FR', { timeZone: 'Indian/Reunion' });
  return `${date} à ${heureReunion(iso)}`;
}

/** « Rappel d'émargement envoyé à 09:00 à 3 apprenants qui n'avaient pas signé » (TF-460). */
export function texteRappel(rappel: { envoyeLe: string; destinataires: number }): string {
  const qui = rappel.destinataires > 1 ? 'apprenants qui n’avaient' : 'apprenant qui n’avait';
  return `Rappel d’émargement envoyé à ${heureReunion(rappel.envoyeLe)} à ${rappel.destinataires} ${qui} pas signé.`;
}
